import { defineStore } from 'pinia';
import {
  createBaseFilterState,
  createFilterActions,
  createFilterGetters,
} from './filterStoreHelpers';
import sortOptions from '@/constants/sortOptions';

const filterAPI = 'api/transport-requests/manage/Accepted';
const options = { sort: sortOptions.dispatchedDate };

export const useDispatchedFilterStore = defineStore('dispatchedFilterStore', {
  state: () => createBaseFilterState(options),
  actions: createFilterActions(filterAPI, options),
  getters: createFilterGetters(),
});
